const DEFAULT_MODEL = {
  data: {},
};

function trackingReducer(model = DEFAULT_MODEL, action = {}) {
  switch (action.type) {
    case 'INIT_TRACKING_MODEL':
      return DEFAULT_MODEL;

    case 'UPDATE_MODEL': {
      const sortedShipments = sortShipments(action.data.shipments);
      const isDummy = getIsDummy(action.data);
      return {
        ...model,
        data: {
          ...model.data,
          ...action.data,
          shipments: sortedShipments,
          isDummy,
        },
        loaded: true,
        selectedShipmentIndex: getSelectedShipmentIndex(model.selectedShipmentIndex, sortedShipments, isDummy),
      };
    }

    case 'SELECT_SHIPMENT':
      return {
        ...model,
        selectedShipmentIndex: action.id,
      };

    case 'ERROR':
      return {
        ...model,
        error: action.error,
      };

    case 'REQUEST_PENDING':
      return {
        ...model,
        isRequestPending: true,
      };

    case 'REQUEST_FINISHED':
      return {
        ...model,
        isRequestPending: false,
      };

    default:
      return model;
  }
}

function getIsDummy(data) {
  if (data?.isDummy !== undefined) {
    return data.isDummy;
  }

  return data?.order?.id.toString().toUpperCase() === 'ORDERID';
}

export function getSelectedShipment(state) {
  const {
    tracking: {
      data: { shipments = [] },
      selectedShipmentIndex,
    },
  } = state;

  return shipments[selectedShipmentIndex];
}

function getSelectedShipmentIndex(selectedShipmentIndex, sortedShipments, ignoreReturnShipments) {
  if (isShipmentIndexSet(selectedShipmentIndex)) {
    return selectedShipmentIndex;
  }

  return getInitialShipmentIndex(sortedShipments, ignoreReturnShipments);
}

function isShipmentIndexSet(selectedShipmentIndex) {
  return selectedShipmentIndex >= 0;
}

function getInitialShipmentIndex(sortedShipments, ignoreReturnShipments) {
  if (ignoreReturnShipments) {
    return 0;
  }

  const firstReturnShipmentIndex = sortedShipments.findIndex((shipment) => shipment.isReturnParcel);
  const returnShipmentFound = firstReturnShipmentIndex !== -1;

  if (returnShipmentFound) {
    return firstReturnShipmentIndex;
  }

  return 0;
}

function sortShipments(shipments) {
  return shipments ? sortOutboundFirst(shipments) : [];
}

function sortOutboundFirst(shipments) {
  return shipments.slice().sort((a, b) => isReturnInt(a) - isReturnInt(b));
}

function isReturnInt(shipment) {
  return Number(!!shipment.isReturnParcel);
}

export default trackingReducer;



// WEBPACK FOOTER //
// ./src/js/reducers/tracking.js